import { FilterRemoveIcon } from './FilterRemoveIcon';

/**
 * author: Austin Andrews
 * id F0D392A7-69A4-4301-8E3B-46A8FC7C3DF9
 * name filter-remove
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-remove.svg
 * tags
 */
export const FunnelRemoveIcon = FilterRemoveIcon;
export default FunnelRemoveIcon